import { getCssVariable } from "../../utils";
import { useLayoutEffect, useRef } from "react";
function getDistance(name) {
    return parseFloat(getCssVariable(name)) || 0;
}
export function isSticky(position, rect, header, placeholder) {
    const viewHeight = window.innerHeight;
    const maxHeight = viewHeight * 0.6;
    if (position === "top") {
        const headerHeight = header.offsetHeight;
        const top = getDistance("tp-space");
        return (rect.top <= top && headerHeight <= maxHeight && headerHeight < rect.bottom);
    }
    else {
        const bottom = getDistance("bt-space");
        const other = placeholder.getBoundingClientRect();
        const headerHeight = placeholder.offsetHeight;
        return (other.bottom + bottom > viewHeight &&
            rect.top + headerHeight + bottom < viewHeight);
    }
}
export function useSticky(position = "top", widen = 0) {
    const ref = useRef(null);
    useLayoutEffect(() => {
        const header = ref.current;
        const placeholder = header[position === "top" ? "nextElementSibling" : "previousElementSibling"];
        const container = header.parentElement;
        container.style.position = "relative";
        function syncHeight() {
            placeholder.style.height = header.clientHeight + "px";
        }
        function place() {
            header.style.left = "0";
            header.style.width = "100%";
            header.style.position = "absolute";
            if (position === "top") {
                header.style.top = "0";
                header.style.marginTop = "0";
            }
            else {
                // Place the element where the DOM would place it, i.e., at the
                // placeholder - the container may continue below it.
                header.style.top = `${placeholder.offsetTop}px`;
                header.style.bottom = "auto";
                header.style.borderBottom = "none";
            }
        }
        function stick() {
            const rect = container.getBoundingClientRect();
            header.style.backdropFilter = "blur(10px)";
            header.style.zIndex = "100";
            if (isSticky(position, rect, header, placeholder)) {
                header.style.left = `${rect.left - widen}px`;
                header.style.width = `${rect.width + 2 * widen}px`;
                header.style.position = "fixed";
                if (position === "top") {
                    header.style.top = "0";
                    header.style.marginTop = "var(--tp-space)";
                }
                else {
                    header.style.borderBottom = "var(--bt-space) solid transparent";
                    header.style.top = "auto";
                    header.style.bottom = "0";
                }
            }
            else {
                place();
            }
        }
        // Sync placeholder height and position dynamically
        const resizeObserver = new ResizeObserver(() => {
            syncHeight();
            stick();
        });
        // IntersectionObserver for performance
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                window.addEventListener("scroll", stick);
                window.addEventListener("resize", stick);
                stick();
            }
            else {
                window.removeEventListener("scroll", stick);
                window.removeEventListener("resize", stick);
                // Reset to normal when container leaves viewport
                place();
            }
        }, { threshold: [0] });
        resizeObserver.observe(header);
        resizeObserver.observe(container);
        observer.observe(container);
        syncHeight();
        return () => {
            window.removeEventListener("scroll", stick);
            window.removeEventListener("resize", stick);
            observer.disconnect();
            resizeObserver.disconnect();
        };
    }, []);
    return ref;
}
//# sourceMappingURL=use-sticky.js.map